export default __webpack_public_path__ + "static/media/visibility.bd6900a0.svg";